'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Component2 = require('../../Component');

var _Component3 = _interopRequireDefault(_Component2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Main = function (_Component) {
    _inherits(Main, _Component);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _this.template = _main2.default;

        _this._inputTheme = function () {
            return Object.assign({}, _this.props.theme, {
                width: '100%'
            });
        };

        _this.state = {
            // текущий элемент списка в фокусе
            focused: null,
            active: false,
            // initial value
            query: props.value
        };

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps, nextContext) {
            if (this.isFocused && (!this.props.children || !this.props.children.length) && nextProps.children && nextProps.children.length) {
                this.open();
            } else if (this.props.children && this.props.children.length && (!nextProps.children || !nextProps.children.length)) {
                this.close();
            }

            if (nextProps.value !== this.state.query) {
                this.setState({ query: nextProps.value });
            }
        }
    }, {
        key: '_handleFocus',
        value: function _handleFocus(e) {
            this.open();
            this.isFocused = true;

            if (typeof this.props.onFocus === 'function') {
                this.props.onFocus(e);
            }

            return this;
        }
    }, {
        key: '_handleBlur',
        value: function _handleBlur(e) {
            this.close();
            this.isFocused = false;

            if (typeof this.props.onBlur === 'function') {
                this.props.onBlur(e);
            }

            return this;
        }
    }, {
        key: '_handleChange',
        value: function _handleChange(e) {
            if (typeof this.props.onChange === 'function') {
                this.props.onChange(e);
            }

            return this.setState({
                query: e.target.value
            });
        }
    }, {
        key: '_handleKeyDown',
        value: function _handleKeyDown(event) {
            if (this.state.active) {
                if (event.keyCode === 40) {
                    this.focusNext();
                } else if (event.keyCode === 38) {
                    this.focusPrev();
                } else if (event.keyCode === 13) {
                    event.preventDefault();
                    this.select();
                    this.close();
                }
            }

            if (typeof this.props.onKeyDown === 'function') {
                this.props.onKeyDown(event);
            }
        }
    }, {
        key: 'open',
        value: function open() {
            return this.setState({
                focused: -1,
                active: true
            });
        }
    }, {
        key: 'close',
        value: function close() {
            var _this2 = this;

            return new Promise(function (resolve) {
                // blur срабатывает первее клика по элементу и список закрывается ДО события клика по элементу
                setTimeout(function () {
                    _this2.setState({
                        focused: -1,
                        active: false
                    }).then(function () {
                        return resolve();
                    });
                }, 300);
            });
        }
    }, {
        key: '_filter',
        value: function _filter() {
            var _this3 = this;

            var pattern = null,
                value = this.state.value,
                result = [];

            if (value) {
                pattern = new RegExp(value, 'i');
            }

            _react2.default.Children.forEach(this.props.children, function (child, i) {
                if (_this3.props.maxListLength && i + 1 > _this3.props.maxListLength) {
                    return;
                }

                if (!pattern || pattern.test(child.props.value)) {
                    result.push(child);
                }
            });

            return result;
        }
    }, {
        key: '_focus',
        value: function _focus() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (this.state.focus !== index) {
                return this.setState({ focused: index });
            } else {
                return Promise.resolve();
            }
        }
    }, {
        key: 'focusNext',
        value: function focusNext() {
            var focused = this.state.focused,
                listLength = this._currentFilteredList.length;

            if (listLength) {
                // следующий индекс не больше чем длинна списка
                if (focused + 1 <= listLength - 1) {
                    focused += 1;
                } else {
                    focused = 0;
                }

                this._focus(focused);
            }
        }
    }, {
        key: 'focusPrev',
        value: function focusPrev() {
            var focused = this.state.focused,
                listLength = this._currentFilteredList.length;

            if (listLength) {
                // следующий индекс не меньше первого
                if (focused - 1 >= 0) {
                    focused -= 1;
                } else {
                    // последний в списке
                    focused = listLength - 1;
                }

                this._focus(focused);
            }
        }

        /**
         * выбор элемента из списка
         * @param {object} element
         * @return {object}
         */

    }, {
        key: 'select',
        value: function select(element) {
            var value = void 0;

            if (!element && this.state.focused !== null) {
                element = this._currentFilteredList[this.state.focused];
                value = element ? element.props.value : null;
            } else if (element) {
                value = element.props.value;
            }

            if (value) {
                this.input.value = value;

                if (typeof this.props.onSelect === 'function') {
                    this.props.onSelect(value, element);
                }
            }

            return this;
        }
    }, {
        key: '_inputRef',
        value: function _inputRef(el) {
            if (typeof this.props.elementRef === 'function') {
                this.props.elementRef(el);
            }

            this.input = el;
        }
    }]);

    return Main;
}(_Component3.default);

Main.defaultProps = {
    // max length of elements list
    maxListLength: 10
};
Main.propTypes = {
    maxListLength: _propTypes2.default.number,
    children: _propTypes2.default.any,
    onFocus: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    onKeyDown: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    onSelect: _propTypes2.default.func,
    elementRef: _propTypes2.default.func,
    value: _propTypes2.default.any,
    theme: _propTypes2.default.object
};
Main.displayName = 'Autocomplete';
exports.default = Main;